export default "__VITE_ASSET__DRNByMW5__"